import {mapState, mapGetters, mapActions} from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'

export default {
    name: 'PartnerForm',
    components: {
        Loading
    },
    metaInfo() {
        let title = this.pageTitle + ' | ' + Constants.SiteInfo.title
        this.setMeta({title: title})
        return this.getMeta
    },
    props: {
        partnerId: String
    },
    data() {
        return {
            loading: true
        }
    },
    mounted() {
        this.init()
    },
    beforeDestroy() {
        this.resetForm()
    },
    computed: {
        ...mapState({
            categoryName: state => state.partner.categoryName
        }),
        ...mapGetters({
            getMeta: 'meta/get',
            getPermission: 'permission/get',
            isRegister: 'partnerForm/isRegister',
            isModify: 'partnerForm/isModify'
        }),
        pageTitle() {
            return this.isRegister ?
                this.categoryName + '新規作成' :
                this.categoryName + '編集'
        }
    },
    methods: {
        ...mapActions({
            setMeta: 'meta/set',
            showError: 'error/show',
            loadModel: 'partnerForm/loadModel',
            resetForm: 'partnerForm/reset'
        }),
        init() {
            this.loading = true
            //TODO
            let partnerParams = {
                partnerUuid: this.partnerId
            }
            let serviceParams = {}
            let serviceDetailParams = {
                serviceUuid: this.userServiceUuid
            }
            // データ読出し
            this.loadModel({
                targetId: this.partnerId,
                partnerParams: partnerParams,
                serviceParams: serviceParams,
                serviceDetailParams: serviceDetailParams
            })
                // eslint-disable-next-line
                .then(res => {
                    this.loading = false
                })
                .catch(error => {
                    this.showError(error || null)
                })
        }
    }
}
